// Imports: local files.
import {
  GET_ALL_FACILITATION_GUIDES_START,
  GET_ALL_FACILITATION_GUIDES_SUCCESS,
  GET_ALL_FACILITATION_GUIDES_FAILED,
  GET_ALL_FACILITATION_GUIDES_RESET,
  GET_ONE_FACILITATION_GUIDE_START,
  GET_ONE_FACILITATION_GUIDE_SUCCESS,
  GET_ONE_FACILITATION_GUIDE_FAILED,
  GET_ONE_FACILITATION_GUIDE_RESET,
  CREATE_FACILITATION_GUIDE_START,
  CREATE_FACILITATION_GUIDE_SUCCESS,
  CREATE_FACILITATION_GUIDE_FAILED,
  CREATE_FACILITATION_GUIDE_RESET,
  UPDATE_ONE_FACILITATION_GUIDE_START,
  UPDATE_ONE_FACILITATION_GUIDE_SUCCESS,
  UPDATE_ONE_FACILITATION_GUIDE_FAILED,
  UPDATE_ONE_FACILITATION_GUIDE_RESET,
  DELETE_ONE_FACILITATION_GUIDE_START,
  DELETE_ONE_FACILITATION_GUIDE_SUCCESS,
  DELETE_ONE_FACILITATION_GUIDE_FAILED,
  DELETE_ONE_FACILITATION_GUIDE_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const facilitationGuidesReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All Facilitation Guides
     * =======================================================================
     */
    case GET_ALL_FACILITATION_GUIDES_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FACILITATION_GUIDES_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FACILITATION_GUIDES_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FACILITATION_GUIDES_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One Facilitation Guide
     * =======================================================================
     */
    case GET_ONE_FACILITATION_GUIDE_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FACILITATION_GUIDE_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FACILITATION_GUIDE_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FACILITATION_GUIDE_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New Facilitation Guide
     * =======================================================================
     */
    case CREATE_FACILITATION_GUIDE_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_FACILITATION_GUIDE_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_FACILITATION_GUIDE_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_FACILITATION_GUIDE_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One Facilitation Guide
     * =======================================================================
     */
    case UPDATE_ONE_FACILITATION_GUIDE_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FACILITATION_GUIDE_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FACILITATION_GUIDE_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FACILITATION_GUIDE_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One Facilitation Guide
     * =======================================================================
     */
    case DELETE_ONE_FACILITATION_GUIDE_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FACILITATION_GUIDE_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FACILITATION_GUIDE_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FACILITATION_GUIDE_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default facilitationGuidesReducer;
